<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p19" title="19">
<figure class="fullpage">
<img alt="" src="image/p019.jpg"/>
<figcaption>
<p class="caption"><a href="#/html/p018">The Ultimate Pancakes</a></p>
</figcaption>
</figure>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p019.vue?ea279b18